<template lang="pug">
  md-table.bordered
    md-table-row
      md-table-head(
        v-for="column in columns"
        :key="column.name || column"
        :md-numeric="column.isNumeric")
        | {{ column.name || column | capitalizeColumnHead }}
    slot
</template>

<script>
export default {
  filters: {
    capitalizeColumnHead(val) {
      return val
        .split(' ')
        .map((v) => {
          if (/^id/i.test(v)) return 'ID';
          if (/of/.test(v)) return v;

          return v.charAt(0).toUpperCase() + v.slice(1);
        })
        .join(' ');
    },
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bordered {
  border: 1px solid #ededed;
  border-radius: 4px;
}
</style>
